module.exports = "<div class=\"mt-3 h7\">\n    QUESTIONS? Corporate care is available at\n    <div class=\"customer_care\">\n      {{ctrl.corporateCareNumber}}\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/corporateCare.html
// module id = 750
// module chunks = 0